
import Navigation from "@/components/navigation.vue";

import { defineComponent } from 'vue';

export default defineComponent ({
  name: 'App',
  components: { Navigation }
})
